import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "cerrix-search-input",
    templateUrl: "./cerrix-search-input.component.html",
    styleUrls: ["./cerrix-search-input.component.scss"],
    imports: [MatIconModule],
})
export class CerrixSearchInputComponent {
    @Input() placeholder: string = "Search...";
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;
    @Input() name: string = "";
    @Input() value: string = "";
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
}
